import { EditableText } from '../components/EditableText';
import './SchedulePage.css';

const CALENDAR_ID = process.env.REACT_APP_GOOGLE_CALENDAR_ID;
const TIMEZONE = process.env.REACT_APP_GOOGLE_CALENDAR_TZ || 'America/Los_Angeles';

export function SchedulePage() {
  const embedUrl = CALENDAR_ID
    ? `https://calendar.google.com/calendar/embed?src=${encodeURIComponent(CALENDAR_ID)}&ctz=${encodeURIComponent(TIMEZONE)}`
    : null;

  return (
    <main className="schedule-page">
      <div className="section-inner">
        <h1>Schedule</h1>
        <EditableText
          id="schedule-intro"
          className="schedule-intro"
          defaultValue="Practices, matches, and club events — all in one place."
        />

        {embedUrl ? (
          <iframe
            className="schedule-calendar"
            src={embedUrl}
            title="SV Rugby Schedule"
            style={{ border: 0 }}
            frameBorder="0"
            scrolling="no"
          />
        ) : (
          // TODO - Replace Surf School: set REACT_APP_GOOGLE_CALENDAR_ID (and optionally
          // REACT_APP_GOOGLE_CALENDAR_TZ) once the club calendar exists and is shared publicly.
          <p className="schedule-placeholder">
            Calendar not configured yet. Set REACT_APP_GOOGLE_CALENDAR_ID to a public Google
            Calendar's ID to display it here.
          </p>
        )}
      </div>
    </main>
  );
}
